/**
 * checks whether the string is meaningful (ie has some non-white space characters)
 * @param  {String} [value=""] input value
 * @return {Boolean}           returns true if the value is a string and has non-white space characters
 */
export default function isMeaningfulString(value="") {
  return typeof value==="string" && value.trim().length>0; //is a string AND has meaningful characters
}
